module.exports = require("./ig-NG.js");